<template>
  <div>
    <img class="banner" src="@/assets/images/image146.png" alt="">
    <img class="banner" src="@/assets/images/image147.png" alt="">
    <div class="bg">
        <div class="list">
            <div>
                <img class="top" src="@/assets/images/image149.png" alt="">
                <div class="bottom"></div>
            </div>
            <div>
                <img class="top" src="@/assets/images/image150.png" alt="">
                <div class="bottom"></div>
            </div>
            <div>
                <img class="top" src="@/assets/images/image151.png" alt="">
                <div class="bottom"></div>
            </div>
            <div>
                <img class="top" src="@/assets/images/image152.png" alt="">
                <div class="bottom"></div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'enterpriseCulture',
  data () {
    return {
    }
  },
  methods: {},
}
</script> 

<style lang='less' scoped>
    .banner{
        width: 100%;
        display: block;
        // height: 860px;
    }
    .bg{
        width: 100%;
        height: 800px;
        background-image: url("../../assets/images/image148.png");
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center center;
        position:relative;
        .list{
            width: 1440px;
            position: absolute;
            display: flex;
            justify-content: space-between;
            bottom: 110px;
            left: 50%;
            transform: translateX(-50%);
            div{
                .top{
                    width: 340px;
                    height: 350px;
                    display: block;
                }
                .bottom{
                    width: 340px;
                    height: 100px;
                    background-color: white;
                    background-repeat: no-repeat;
                    background-position: center center;
                }
                &:nth-child(1){
                    .bottom{
                        background-image: url("../../assets/images/image153.png");
                    }
                    &:hover{
                        .bottom{
                            background-color: #DB0000;
                            background-image: url("../../assets/images/image157.png");
                        }
                    }
                }
                &:nth-child(2){
                    .bottom{
                        background-image: url("../../assets/images/image154.png");
                    }
                    &:hover{
                        .bottom{
                            background-color: #DB0000;
                            background-image: url("../../assets/images/image158.png");
                        }
                    }
                }
                &:nth-child(3){
                    .bottom{
                        background-image: url("../../assets/images/image155.png");
                    }
                    &:hover{
                        .bottom{
                            background-color: #DB0000;
                            background-image: url("../../assets/images/image159.png");
                        }
                    }
                }
                &:nth-child(4){
                    .bottom{
                        background-image: url("../../assets/images/image156.png");
                    }
                    &:hover{
                        .bottom{
                            background-color: #DB0000;
                            background-image: url("../../assets/images/image160.png");
                        }
                    }
                }
            }
        }
    }
</style>
